import { LOCAL_STORAGE, MODAL_TYPES } from 'app/commons/constants'
import { ICON_DELIVEREE_GREEN, ICON_TRANSPORTIFY_GREEN } from 'app/commons/constants/image.const'
import * as Utils from 'app/commons/helpers/utils'
import authApi from 'app/services/authApi'
import { handleSubmitNewPwd } from 'app/store/auth/authAction'
import { modalCreateActions } from 'app/store/modal/modalSlice'
import { getAndCheckTokenCaptCha } from 'app/utils/authentication'
import { Formik } from 'formik'
import queryString from 'query-string'
import * as Yup from 'yup'

import React, { Component } from 'react'
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'

import moment from 'moment'

import './style.scss'

const INIT_VALUES_FORM_RESET_PWD = { email: '' }
const INIT_VALUES_FORM_NEW_PWD = { password: '', rePassword: '' }

const ValidateResetForm = (t) =>
  Yup.object().shape({
    email: Yup.string().email(t('common.login.emailInvalid')).required(t('common.login.emailRequired')),
  })

const ValidateNewPwd = Yup.object().shape({
  password: Yup.string()
    .required('common.resultNewPwdForm.requiredPassword')
    .min(6, 'common.resultNewPwdForm.minLengthPassword'),
  rePassword: Yup.string()
    .required('common.resultNewPwdForm.requiredPassword')
    .min(6, 'common.resultNewPwdForm.minLengthPassword')
    .oneOf([Yup.ref('password')], 'common.resultNewPwdForm.equalTo'),
})

class ResetPassword extends Component {
  static renderTextError(error, textError, text) {
    if (error) {
      return [
        <i key={text} className="material-icons mr5 Icon b">
          error
        </i>,
        textError,
      ]
    }
    return text
  }

  /**
   * action = 1 : Reset Password Screen
   * action = 4 : New Password Screen
   * action = 5 : Result New Password Screen
   */
  constructor(props) {
    super()
    this.state = {
      action: props.action || 1,
      expired: false,
      error: false,
      showPassword: false,
      showRePassword: false,
      closeForm: false,
      queryString: null,
      emailReset: '',
    }
  }

  componentDidMount() {
    const { location } = this.props
    if (location) {
      const queryUrl = queryString.parse(location.search)
      this.setState({ queryString: queryUrl })
      const { reset_password_token, reset_password_sent_at } = queryUrl
      let { action } = queryUrl
      if (reset_password_token && reset_password_sent_at) {
        const isTimeValid = !this.isTokenExpired()
        if (reset_password_token && reset_password_sent_at) {
          action = !isTimeValid ? 1 : 4
        }
        if (action) {
          this.setState({ action, expired: !isTimeValid })
        }
      }
    }
  }

  isTokenExpired = () => {
    const { location } = this.props
    const queryUrl = queryString.parse(location.search)
    const { reset_password_sent_at } = queryUrl
    if (reset_password_sent_at) {
      const start = new Date(1000 * reset_password_sent_at)
      const end = moment(start).add('day', 1)
      const now = new Date()
      const isTimeValid = moment(now).isBetween(moment(start), end)
      return !isTimeValid
    }
  }

  showPassword = (condition) => (condition ? 'green' : 'gray')

  toggleShowPassword = (obj) => () => {
    this.setState((prevState) => ({
      ...prevState,
      [obj]: !prevState[obj],
    }))
  }

  changeTypeInput = (cond) => (cond ? 'input' : 'password')

  handleSubmitNewPwd = (values) => {
    const { submitNewPwd, prePassword } = this.props
    submitNewPwd({
      ...values,
      currentPassword: prePassword,
      cb: () => {
        window.location.reload()
      },
    })
  }

  hanldeSubmitResetPwd = async (values) => {
    const { t, openModal, enableCaptchaVerification, googleReCaptchaProps } = this.props
    const { email } = values
    try {
      if (email) {
        let xRecaptchaToken
        if (enableCaptchaVerification) {
          const executeRecaptcha = googleReCaptchaProps?.executeRecaptcha
          xRecaptchaToken = await getAndCheckTokenCaptCha(executeRecaptcha, 'password_reset')
        }
        const result = await authApi.resetPassword(
          {
            login: email.trim().toLowerCase(),
          },
          xRecaptchaToken
        )
        if (result.error) {
          toast.error(result.error)
        } else {
          toast.success(t('common.resetPwdForm.sendParanoidInstructions'))
          openModal({ typeModal: MODAL_TYPES.LOGIN })
        }
      }
    } catch (error) {
      console.debug(error)
    }
  }

  //  Reset Password Screen
  renderResetPasswordAction1() {
    const { expired, emailReset } = this.state
    const { t, openModal } = this.props
    return (
      <div className="reset-password">
        <div className="reset-password--header">{t('common.newPwdForm.resetPwd')}</div>
        {expired === true && (
          <div className="reset-password-expired">
            <div>
              <span> {t('common.resetPwdForm.expiredNotify')} </span>
              <br />
              <span>{t('common.resetPwdForm.expiredReqNewLink')}</span>
            </div>
            <div>{t('common.resultForgotPwd.notifyExpired')}</div>
          </div>
        )}
        <div className="reset-password--container">
          <Formik
            initialValues={
              !emailReset ? INIT_VALUES_FORM_RESET_PWD : { ...INIT_VALUES_FORM_RESET_PWD, email: emailReset }
            }
            validationSchema={ValidateResetForm(t)}
            onSubmit={this.hanldeSubmitResetPwd}
          >
            {(props) => {
              const {
                values: { email },
                handleChange,
                handleBlur,
                isSubmitting,
                errors: { email: emailError },
                touched: { email: emailTouched },
                handleSubmit,
              } = props
              const isError = !!emailError && emailTouched
              return (
                <form className="Form-Container" onSubmit={handleSubmit}>
                  <div className={`form-group mx-auto ${isError && 'Form-Error'}`}>
                    <label htmlFor="email">{t('common.editProfile.email')}</label>
                    <input
                      type="email"
                      className="form-control reset-password--input"
                      id="email"
                      value={email}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                    {isError && <div className="error">{t(emailError)}</div>}
                  </div>
                  <div className="reset-password--action text-center">
                    <button type="submit" disabled={isSubmitting} className="Button green h36 w-100">
                      {t('common.resetPwdForm.getALinkToResetPassword')}
                    </button>
                  </div>
                </form>
              )
            }}
          </Formik>
        </div>
        <div className="reset-password--footer">
          {t('signup.alreadyHaveAccount', { app_name: Utils.appName() })}{' '}
          <div className="Link-Button" onClick={() => openModal({ typeModal: MODAL_TYPES.LOGIN })} role="presentation">
            {t('signup.logInHere')}
          </div>
        </div>
      </div>
    )
  }

  //  New Password Screen
  renderResetPasswordAction4() {
    const { t } = this.props
    const { showPassword, showRePassword } = this.state
    const passwordClass = this.showPassword(showPassword)
    const rePasswordClass = this.showPassword(showRePassword)
    return (
      <div className="reset-password">
        <div className="reset-password--header">{t('common.resultNewPwdForm.changePassword')}</div>
        <div className="reset-password--container">
          <Formik
            initialValues={INIT_VALUES_FORM_NEW_PWD}
            validationSchema={ValidateNewPwd}
            onSubmit={this.handleSubmitNewPwd}
          >
            {(props) => {
              const { password, rePassword } = props.values
              const { handleChange, handleBlur, handleSubmit } = props
              const { password: passwordErr, rePassword: rePasswordErr } = props.errors

              const { password: passwordTouched, rePassword: rePasswordTocuhed } = props.touched
              const showErrPassword = passwordErr && passwordTouched
              const showErrRePassword = rePasswordErr && rePasswordTocuhed

              return (
                <form className="Form-Container" onSubmit={handleSubmit}>
                  <div className={`form-group mx-auto ${showErrPassword && 'Form-Error'}`}>
                    <label htmlFor="password">{t('common.resultNewPwdForm.newPassword')}</label>
                    <div className="input-group mb-1">
                      <input
                        type={this.changeTypeInput(showPassword)}
                        className="form-control reset-password--input"
                        id="password"
                        name="password"
                        value={password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text cur-pointer">
                          <i
                            onClick={this.toggleShowPassword('showPassword')}
                            className={`material-icons Icon xb ${passwordClass}`}
                            role="presentation"
                          >
                            visibility
                          </i>
                        </span>
                      </div>
                    </div>
                    {showErrPassword && <div className="error">{t(passwordErr)}</div>}
                  </div>
                  <div className={`form-group mx-auto ${showErrRePassword && 'Form-Error'}`}>
                    <label htmlFor="re_password">{t('common.resultNewPwdForm.confirmNewPassword')}</label>
                    <div className="input-group mb-1">
                      <input
                        type={this.changeTypeInput(showRePassword)}
                        className="form-control reset-password--input"
                        id="re_password"
                        name="rePassword"
                        value={rePassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text cur-pointer">
                          <i
                            onClick={this.toggleShowPassword('showRePassword')}
                            className={`material-icons Icon xb ${rePasswordClass}`}
                            role="presentation"
                          >
                            visibility
                          </i>
                        </span>
                      </div>
                    </div>
                    {showErrRePassword && <div className="error">{t(rePasswordErr)}</div>}
                  </div>
                  <div className="reset-password--action text-center mb-0">
                    <button type="submit" className="Button green h36 w-100">
                      {t('common.resultNewPwdForm.changeMyPassword')}
                    </button>
                  </div>
                </form>
              )
            }}
          </Formik>
        </div>
      </div>
    )
  }

  // Result New Password Screen
  renderResetPasswordAction5() {
    const { history, openModal } = this.props
    const { t } = this.props
    return (
      <div className="Popup-Body reset-password--five">
        <div className="reset-password--five__text">{t('common.resultNewPwdForm.notify')}</div>
        <div className="reset-password--action Button-Action text-center">
          <button
            onClick={() => {
              localStorage.clear()
              history.push('/')
              openModal({ typeModal: MODAL_TYPES.LOGIN })
            }}
            className="btn Button-Submit"
            type="button"
          >
            {t('common.resultNewPwdForm.login')}
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { action, closeForm } = this.state
    const { closeModal } = this.props
    const countryCode = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)

    const LOGO_ICON = countryCode === 'ph' ? ICON_TRANSPORTIFY_GREEN : ICON_DELIVEREE_GREEN

    return closeForm ? (
      ''
    ) : (
      <div className="popup-auth">
        <div className="auth-body reset-password">
          {action !== 4 && (
            <div className="auth-close">
              <i
                onClick={() => {
                  closeModal()
                }}
                className="material-icons"
                role="presentation"
              >
                close
              </i>
            </div>
          )}
          <div className="auth-logo">
            <img src={LOGO_ICON} alt="deliveree" />
          </div>
          {+action === 1 && this.renderResetPasswordAction1()}
          {+action === 4 && this.renderResetPasswordAction4()}
          {+action === 5 && this.renderResetPasswordAction5()}
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  newPwdState: state.auth.newPwd,
  authAction: state.auth.action,
  enableCaptchaVerification: state.configuration?.data?.enable_captcha_verification,
})

const actions = {
  submitNewPwd: handleSubmitNewPwd,
  ...modalCreateActions,
}

export default connect(mapState, actions)(withTranslation()(withRouter(withGoogleReCaptcha(ResetPassword))))
